import React from "react";
import Routes from "../../components/Routes";
import { Switch, BrowserRouter, Route} from "react-router-dom";
import { getUserConfirmation } from "./getUserConfirmation";
import { connect } from "react-redux";
import { compose } from "redux";
import { signOutAction } from "../../containers/Authentication/redux/actions";
import DeeplinkLanding from "../DeeplinkLanding";

// Deeplink landing is a fully public route that must render outside the
// admin auth flow (no sidebar, no header, no Okta check). We intercept the
// /deeplink/landing path here before delegating to the dashboard router.
const isDeeplinkLandingPath = pathname =>
  typeof pathname === "string" && pathname.startsWith("/deeplink/landing");

// Issue 3193: the /deeplink/qr scan counter that used to sit beside this route
// was removed. Its only way in was the QR on the desktop landing page, which is
// gone now that desktop visitors are redirected to the public website, and the
// customer no longer wants qr_scan recorded.

function App() {
  if (isDeeplinkLandingPath(window.location.pathname)) {
    return (
      <BrowserRouter>
        <Switch>
          <Route path="/deeplink/landing" component={DeeplinkLanding} />
        </Switch>
      </BrowserRouter>
    );
  }

  const oNeedAuth = JSON.parse(localStorage.getItem("NeedAuth"));
  return (
    <BrowserRouter getUserConfirmation={getUserConfirmation}>
    <Switch>
      <Routes  OKTAExpireUTC={oNeedAuth?.OKTAExpireUTC} />
    </Switch>
  </BrowserRouter>
  );
}

const withConnect = connect(
  state => ({
    ...state.auth
  }),
  {
    signOutAction
  }
);

export default compose(withConnect)(App);
